import React from 'react';
import Snippet from './Snippet';
import Title from './Title';
import Preview from './Preview';
import Footer from './Footer';
import {Box, PreviewContainer} from '../../../../styled';
import EntityIcon from '../../../../components/EntityIcon/EntityIcon';

const Gmail = ({ item, isPreview }: any) => {
  if (isPreview) {
    return (
      <Box display="flex" flexDirection="column" overflow="hidden" width="100%">
        <Box display="flex" alignItems="center">
          <Box mr={20}>
            <EntityIcon entityName={item.pl} />
          </Box>
          <Title title={item.title} sender={item.sender} />
        </Box>
        <PreviewContainer
          display="flex" flexDirection="column"
          ml={[0, 60]} flex="1"
        >
          <Preview item={item} />
          <Footer item={item} />
        </PreviewContainer>
      </Box>
    )
  }
  return (
    <>
      <Title title={item.title} sender={item.sender} />
      <Snippet text={item.resultSnippet} />
      <Footer item={item} />
    </>
  )
}

export default Gmail;